<template>
	<div id="signup-form">
		<loading
			:active.sync="isLoading"
			:can-cancel="true"
			:on-cancel="onCancel"
			:is-full-page="fullPage"
		></loading>
		<b-alert
			:show="dismissCountDown"
			dismissible
			variant="danger"
			@dismissed="dismissCountDown = 0"
			@dismiss-count-down="countDownChanged"
		>
			{{ err }}
		</b-alert>
		<div class="appView">
			<div class="gatekeeperView signUp">
				<div class="gatekeeperContentView">
					<a :href="baseUrl"><div class="logo"></div></a>

					<form class="gatekeeperForm">
						<div class="formHeader">
							<div class="title">
								Create an account to start organizing your receipts today!
							</div>
							<div class="separator"></div>
						</div>

						<div class="formContent tableView">
							<div class="tableSection sectionCredentials">
								<div
									class="block inputCell"
									:class="[emailErrorMessage ? 'errorField' : 'email']"
								>
									<div class="title">Email</div>
									<div class="input placeholder">
										<input
											v-model="email"
											type="email"
											placeholder="name@domain.com"
											class="form-control"
											@focus="validateEmail"
											@input="validateEmail"
											@blur="emailInputBlur"
											autofocus
										/>
									</div>
								</div>

								<div class="error" v-if="emailErrorMessage">
									<div class="input placeholder">
										{{ emailErrorMessage }}
									</div>
								</div>

								<div
									class="block inputCell"
									:class="[passwordErrorMessage ? 'errorField' : 'password']"
								>
									<div class="title">Password</div>
									<div class="input placeholder">
										<input
											v-model="password"
											type="password"
											placeholder="••••••••••••••"
											class="form-control"
											@focus="passwordInputFocus"
											@blur="passwordInputBlur"
											@input="passwordInputChange"
										/>
									</div>
								</div>

								<div class="error" v-if="passwordErrorMessage">
									<div class="input placeholder">
										{{ passwordErrorMessage }}
									</div>
								</div>

								<div>
									<ul class="input hideValidateMessage">
										<li>Must contain an uppercase letter</li>
										<li>Must contain a lowercase letter</li>
										<li>Must contain a number</li>
										<li>Must contain a special character</li>
										<li>Minimum 8 characters long</li>
									</ul>
								</div>
							</div>

							<div class="tableSection sectionCredentials">
								<div
									class="block inputCell"
									:class="[firstNameErrorMessage ? 'errorField' : 'firstName']"
								>
									<div class="title">First Name</div>
									<div class="input placeholder">
										<input
											type="text"
											v-model="firstname"
											placeholder="Joey"
											name="firstname"
											class="form-control name"
											@focus="firstNameInputFocus"
											@input="firstNameInputChange"
											@blur="firstNameInputBlur"
										/>
									</div>
								</div>

								<div class="error" v-if="firstNameErrorMessage">
									<div class="input placeholder">
										{{ firstNameErrorMessage }}
									</div>
								</div>

								<div
									class="block inputCell"
									:class="[lastNameErrorMessage ? 'errorField' : 'lastName']"
								>
									<div class="title">Last Name</div>
									<div class="input placeholder">
										<input
											type="text"
											v-model="lastname"
											placeholder="Smith"
											name="lastname"
											class="form-control name"
											@focus="lastNameInputFocus"
											@input="lastNameInputChange"
											@blur="lastNameInputBlur"
										/>
									</div>
								</div>

								<div class="error" v-if="lastNameErrorMessage">
									<div class="input placeholder">
										{{ lastNameErrorMessage }}
									</div>
								</div>
							</div>

							<div
								class="button buttonLarge"
								:class="[
									!(
										isValidEmail &&
										isValidPassword &&
										isValidFirstName &&
										isValidLastName
									)
										? 'buttonDisabled'
										: 'buttonTint'
								]"
								@click="createAccount"
							>
								<button type="submit" class="title signupButton">
									Sign Up
								</button>
							</div>

							<div class="legalFootnote">
								By clicking "Sign Up", you acknowledge our
								<a href="/privacy" target="_blank" class="action"
									>Privacy&nbsp;Policy</a
								>
								and agree to the
								<a href="/terms" target="_blank" class="action"
									>Terms&nbsp;of&nbsp;Service</a
								>.
							</div>
						</div>
					</form>

					<div class="additionalActions">
						<div
							class="button buttonLarge buttonLogin buttonActionTranslucent"
							@click="goToSignIn()"
						>
							<div class="title">
								Already have an account? Log In
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Auth from "@aws-amplify/auth";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
	name: "Signup",
	components: {
		Loading
	},
	data() {
		return {
			baseUrl: window.location.origin,
			firstname: "",
			lastname: "",
			email: "",
			password: "",
			isLoading: false,
			fullPage: true,
			dismissSecs: 5,
			dismissCountDown: 0,
			err: "",
			emailPattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			isValidEmail: false,
			emailErrorMessage: "",
			passwordPattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/,
			isValidPassword: false,
			passwordErrorMessage: "",
			namePattern: /^[a-zA-Z]+[a-zA-Z]+$/,
			isValidFirstName: false,
			firstNameErrorMessage: "",
			isValidLastName: false,
			lastNameErrorMessage: ""
		};
	},
	methods: {
		goToSignIn() {
			this.$router.push({ name: "signin" });
		},
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown;
		},
		onCancel() {},
		validateEmail() {
			this.isValidEmail = this.emailPattern.test(this.email);
			this.emailErrorMessage = "";
		},
		emailInputBlur() {
			if (this.email) {
				this.isValidEmail = this.emailPattern.test(this.email);
				this.emailErrorMessage = this.emailPattern.test(this.email)
					? ""
					: "Invalid Email";
			}
		},
		passwordInputFocus() {
			this.passwordErrorMessage = "";
			this.isValidPassword = this.passwordPattern.test(this.password);
			document
				.querySelector(".hideValidateMessage")
				.classList.add("showValidateMessage");
		},
		passwordInputChange() {
			this.isValidPassword = this.passwordPattern.test(this.password);
		},
		passwordInputBlur() {
			document
				.querySelector(".hideValidateMessage")
				.classList.remove("showValidateMessage");
			if (this.password) {
				this.isValidPassword = this.passwordPattern.test(this.password);
				this.passwordErrorMessage = this.passwordPattern.test(this.password)
					? ""
					: "Invalid Password";
			}
		},
		firstNameInputFocus() {
			this.firstNameErrorMessage = "";
			this.isValidFirstName = this.namePattern.test(this.firstname);
		},
		firstNameInputChange() {
			this.isValidFirstName = this.namePattern.test(this.firstname);
		},
		firstNameInputBlur() {
			if (this.firstname) {
				this.isValidFirstName = this.namePattern.test(this.firstname);
				this.firstNameErrorMessage = this.namePattern.test(this.firstname)
					? ""
					: "Invalid First Name";
			}
		},
		lastNameInputFocus() {
			this.lastNameErrorMessage = "";
			this.isValidLastName = this.namePattern.test(this.lastname);
		},
		lastNameInputChange() {
			this.isValidLastName = this.namePattern.test(this.lastname);
		},
		lastNameInputBlur() {
			if (this.lastname) {
				this.isValidLastName = this.namePattern.test(this.lastname);
				this.lastNameErrorMessage = this.namePattern.test(this.lastname)
					? ""
					: "Invalid Last Name";
			}
		},
		validateLastName() {
			this.isValidLastName = !!this.lastname;
		},
		createAccount() {
			const form = document.querySelector(".gatekeeperForm");
			form.addEventListener("submit", event => {
				event.preventDefault();
				if (!this.email) {
					this.emailErrorMessage = "Email is required";
				} else if (!this.isValidEmail) {
					this.emailErrorMessage = "Invalid Email";
				}

				if (!this.password) {
					this.passwordErrorMessage = "Password is required";
				} else if (!this.isValidPassword) {
					this.passwordErrorMessage = "Invalid Password";
				}

				if (!this.firstname) {
					this.firstNameErrorMessage = "First Name is required";
				}

				if (!this.lastname) {
					this.lastNameErrorMessage = "Last Name is required";
				}
			});

			if (
				this.isValidEmail &&
				this.isValidPassword &&
				this.isValidFirstName &&
				this.isValidLastName
			) {
				Auth.signUp({
					username: this.email,
					password: this.password,
					attributes: {
						name: this.firstname,
						family_name: this.lastname
					},
					validationData: []
				})
					.then(data => {
						this.$router.push({ name: "signin", query: { email: this.email } });
					})
					.catch(err => {
						this.isLoading = false;
						this.err = err.message;
						this.emailErrorMessage =
							"There's already an account with this email";
					});
			}
		}
	}
};
</script>
